var Base64 = {

    // private property
    _keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

    // public method for encoding
    encode : function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = Base64._utf8_encode(input);

        while (i < input.length) {

            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output +
                this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

        }

        return output;
    },

    // public method for decoding
    decode : function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {

            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }

        }

        output = Base64._utf8_decode(output);

        return output;

    },

    // private method for UTF-8 encoding
    _utf8_encode : function (string) {
        string = string.replace(/\r\n/g,"\n");
        var utftext = "";

        for (var n = 0; n < string.length; n++) {

            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }

        return utftext;
    },

    // private method for UTF-8 decoding
    _utf8_decode : function (utftext) {
        var string = "";
        var i = 0;
        var c = c1 = c2 = 0;

        while ( i < utftext.length ) {

            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            }
            else if((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i+1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            }
            else {
                c2 = utftext.charCodeAt(i+1);
                c3 = utftext.charCodeAt(i+2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }

        }

        return string;
    }

}

var WCAG_UTILS = {

    appFormWCAGPatches : function () {
        WCAG_UTILS.dateTypeWCAGPatch();
        WCAG_UTILS.richTextTypeWCAGPatch();
        WCAG_UTILS.singleSelectTypeWCAGPatch();
        WCAG_UTILS.multiSelectTypeWCAGPatch();
        WCAG_UTILS.radioTypeWCAGPatches();
        WCAG_UTILS.checkboxTypeWCAGPatch();
        WCAG_UTILS.headingsWCAGPatch();
        WCAG_UTILS.stepsNavWCAGPatch();
        WCAG_UTILS.quillWCAGPatch();
        WCAG_UTILS.customGridTypeWCAGPatch();
        WCAG_UTILS.customListTypeWCAGPatch();
    },

    dateTypeWCAGPatch : function () {
        try {                  	
            // WCAG Patch for DATE TYPE
            $('.formio-component-datetime').each(function (index) {
                try {
                    var itemLabel = $(this).find('label').text();
                    $(this).find("input.form-control.input").attr("aria-label", itemLabel); 
                    $(".flatpickr-calendar .flatpickr-current-month").find('select').attr("aria-label", "Select month"); 
                } catch (innerErr) {
                    console.log('Fail to apply WCAG patch for date component index:' + index);
                }
            }); 
        }
        catch(err)
        {
            console.log('Fail to apply WCAG patch for date components: {}', err);
        }    
    },

    richTextTypeWCAGPatch : function () {
        try {  
            // WCAG patch for WYSIWYG Textarea
            setTimeout(function () {
                $('.formio-component-textarea').each(function (index) {
                    try {
                        if($(this).find(".formio-wysiwyg-editor").length){
                            var itemLabel = $(this).find('label').text();
                            $(this).attr("aria-label", 'Section editable label:' +itemLabel);
                            $(this).attr("role", "application");
                            $(this).attr("tabindex", "0");
                        } 
                    } catch (innerErr) {
                        console.log('Fail to apply WCAG patch for WYSIWYG component index:' + index);
                    }
                });                                    
            }, 100);
        }
        catch(err)
        {
            console.log('Fail to apply WCAG patch for WYSIWYG components: {}', err);
        }  
    },

    singleSelectTypeWCAGPatch : function () {
        try {
            //WCAC Patch for SINGLE SELECT TYPE
            $("div.formio-choices[data-type='select-one']").each(function (index) {
                try {
                    var itemLabel = $(this).closest(".formio-component-select").find('label').text();
                    var itemValue = $(this).find("select option:selected").text();
                    if(itemValue === ''){
                        $(this).find("div.form-control").attr("aria-label", itemLabel);
                    } else {
                        $(this).find("div.form-control").attr("aria-label", (itemLabel+' : '+itemValue +' selected'));
                        $(this).find("button.choices__button").attr("aria-label", 'Remove '+itemValue);
                    }
                } catch (innerErr) {
                    console.log('Fail to apply WCAG patch for single-select component index:' + index);
                }

            });
        }
        catch(err)
        {
            console.log('Fail to apply WCAG patch for single select components: {}', err);
        }
    },

    multiSelectTypeWCAGPatch : function () {
        try {
            //WCAC Patch for MULTI SELECT TYPE
            setTimeout(function () {
                $(".formio-component-select").each(function (index) {
                    $(this).find("div.formio-choices[data-type='select-multiple']").each(function (index) {
                        try {
                            $(this).attr("tabindex", "0");
                            var itemLabel = $(this).closest(".formio-component-select").find('label').text();
                            var itemValue = [];
                            $(this).find("select option:selected").each(function (index) {
                                itemValue.push($(this).text());
                            });
                            if(itemValue.length == 0){
                                $(this).attr("aria-label", itemLabel);
                            } else {
                                $(this).attr("aria-label", (itemLabel+' : '+itemValue +' selected'));
                                
                                $(this).find("div.choices__item choices__item--selectable").each(function (index) {
                                    $(this).find("button.choices__button").attr("aria-label", 'Remove '+itemValue[index]);
                                });
                            }
                        } catch (innerErr) {
                            console.log('Fail to apply WCAG patch for multi-select component index:' + index);
                        }
                    });  
                }); 
            }, 100);
        }
        catch(err)
        {
            console.log('Fail to apply WCAG patch for multi select components: {}', err);
        }
    },

    customGridTypeWCAGPatch : function () {
        try {
            // WCAG patch for CUSTOM_GRID component
            $('.smartGrid-formioCustom').each(function (indexGrid) {
                try {
                    $(this).find("table tbody tr").each(function(indexTr)
                    {
                        $(this).find("td").each(function(index)
                        {
                            var ariaLabel = $(this).closest("table").find("thead tr th").eq(index).text();
                            
                            $(this).find("input, select, textarea").each(function()
                            {

                                if($(this).attr('id') && $(this).attr('id') != null && $(this).attr('id').trim() != "")
                                {

                                    var strId = $(this).attr('id');
                                    
                                    if(strId.indexOf('_idx_') > 0)
                                    {
                                        strId =  strId.substring(0, strId.indexOf('_idx_')); 
                                    }

                                    $(this).attr('id', strId.concat("_idx_") + indexTr );    
                                    
                                    //Fix dates and hidden fields
                                    if($(this).is(':hidden'))
                                    {
                                        $(this).attr('id',  $(this).attr('id') + '_hidden');
                                    }

                                    //Fix choices dropdown fields
                                    if($(this).hasClass('choices__list'))
                                    {
                                        $(this).attr('id',  $(this).attr('id').concat('_choices'));
                                    }

                                    //Fix choices select fields
                                    if($(this).prop('tagName')=="SELECT")
                                    {
                                        $(this).attr('id',  $(this).attr('id').concat('_select'));
                                    }

                                }
                                $(this).attr("aria-label", ariaLabel);
                                if($(this).find("select").parent().hasClass("form-control")){
                                    $(this).find("select").parent().attr("aria-label",ariaLabel);
                                }
                            });
                            
                            //FIX FORM HIDDEN TD DUPLICATED ID
                            if($(this).find(".rasp-hidden-field .rasp-hidden-column"))
                            {
                                var strId = $(this).find(".rasp-hidden-field .rasp-hidden-column").attr('id');
                                if(strId)
                                {    
                                    $(this).find(".rasp-hidden-field .rasp-hidden-column").attr('id', strId.concat("_idx_") + indexTr );
                                }
								
                            };

                        });	
                    });  
                    
                    if($(this).find("> label.control-label").length){
                        $(this).find("> label.control-label").attr("aria-label",$(this).find("> label.control-label").text());
                        //$(this).find("> label.control-label").attr("tabindex", "0");
                    }

                } catch (innerErr) {
                    console.log('Fail to apply WCAG patch for custom-grid component index:' + indexGrid);
                }
            });
        }
        catch(err)
        {
            console.log('Fail to apply WCAG patch for custom-grid components: {}', err);
        }
    },

    customListTypeWCAGPatch : function () {
        try {
            // WCAG patch for CUSTOM_GRID component
            $('.smartCardList-formioCustom').each(function (indexList) 
            {
                $(this).find("table tbody tr").each(function(indexTr)
                { 
                    $(this).find("td").each(function(index)
                    {
                        $(this).find("input, select, textarea").each(function()
                        {
                            try
                            {
                                if($(this).attr('id') && $(this).attr('id') != null && $(this).attr('id').trim() != "")
                                {
                                    var strId = $(this).attr('id');
                                    
                                    if(strId.indexOf('_idx_') > 0)
                                    {
                                        strId =  strId.substring(0, strId.indexOf('_idx_')); 
                                    }
        
                                    $(this).attr('id', strId.concat("_idx_") + indexTr );
                                    
                                    //Fix dates and hidden fields
                                    if($(this).is(':hidden'))
                                    {
                                        $(this).attr('id',  $(this).attr('id') + '_hidden');
                                    }

                                    //Fix choices dropdown fields
                                    if($(this).hasClass('choices__list'))
                                    {
                                        $(this).attr('id',  $(this).attr('id').concat('_choices'));
                                    }

                                    //Fix choices select fields
                                    if($(this).prop('tagName')=="SELECT")
                                    {
                                        $(this).attr('id',  $(this).attr('id').concat('_select'));
                                    }
                                    
                                }
                            }
                            catch(innerErr)
                            {
                                console.log('Fail to apply WCAG patch for: '+ strId +'. Error: ', innerErr);
                            }
                            
                        });
                        

                        //FIX FORM DIV DUPLICATED ID
                        if($(this).find("div .smartCardList-element-formioCustom"))
                        {
                            var strId = $(this).find("div .smartCardList-element-formioCustom").attr('id');
                            if(strId)
                            {    
                                $(this).find("div .smartCardList-element-formioCustom").attr('id', strId.concat("_idx_") + indexTr );
                            }
                            
                        };

                    });
                });
            
            });
        }
        catch(err)
        {
            console.log('Fail to apply WCAG patch for custom-list components: {}', err);
        }
    },
   
    checkboxTypeWCAGPatch : function () {
        try {
            // WCAG patch for Checkbox component
            $('.formio-component-selectboxes').each(function (index) {
                try {
                    $(this).attr("role","group");
                    var groupLabel = $(this).find('>.control-label').text();
                    $(this).attr("aria-label", 'Section group:' +groupLabel);
                    $(this).find(".form-check.checkbox").each(function(index){
                        var label = $(this).find("label").attr("for");
                        label = label.replace(/\s/g,'');
                        $(this).find("label").attr("for",label);
                        $(this).find(".form-check-input").attr("id",label);
                    });                                        	
                } catch (innerErr) {
                    console.log('Fail to apply WCAG patch for checkbox component index:' + index);
                }
            });    
        }
        catch(err)
        {
            console.log('Fail to apply WCAG patch for checkbox components: {}', err);
        }
    },

    radioTypeWCAGPatches : function () {
        try {
            // WCAG patch for Radio component
            $('.formio-component-radio').each(function (index) {
                try {
                    $(this).attr("role","group");
                    var groupLabel = $(this).find('>.control-label').text();
                    $(this).attr("aria-label", 'Section group:' +groupLabel);
                    $(this).find(".form-check.radio").each(function(index){
                        var label = $(this).find("label").attr("for");
                        label = label.replace(/\s/g,'');
                        $(this).find("label").attr("for",label);
                        $(this).find(".form-check-input").attr("id",label);
                    });                                        	
                } catch (innerErr) {
                    console.log('Fail to apply WCAG patch for radio component index:' + index);
                }
            }); 
        }
        catch(err)
        {
            console.log('Fail to apply WCAG patch for radio components: {}', err);
        }
    },

    headingsWCAGPatch : function () {
        try {                  	
            // WCAG Patch for Headings
            $("h1, h2, h3, h4, h5, h6").each(function (index) {
                try {
                    $(this).attr("role", "heading");
                    //$(this).attr("tabindex", "0");
                } catch (innerErr) {
                    console.log('Failed to apply WCAG patch for heading index:' + index);
                }
            }); 
        }
        catch(err)
        {
            console.log('Fail to apply WCAG patch for heading components: {}', err);
        }    
    },
    
   stepsNavWCAGPatch : function () {
        try {                  	
            // WCAG Patch for Steps navigation
            $(".formClient nav").each(function (index) {
                try {
                    $(this).removeAttr("aria-label");
                    $(this).attr("role", "navigation");
                    $(this).attr("tabindex", "0");
                    $(this).find("ul li").each(function (index) {   
                        //$(this).attr("role", "link");
                        $(this).attr("tabindex", "0");
                        if($(this).hasClass("active")){
                            $(this).attr("aria-current", "step");
                        }
                    }); 

                } catch (innerErr) {
                    console.log('Failed to apply WCAG patch for navigation steps:' + index);
                }
            }); 
        }
        catch(err)
        {
            console.log('Fail to apply WCAG patch for navigation steps: {}', err);
        }    
    },
    
    quillWCAGPatch : function () {
        try {                  	
            // WCAG Patch for disabling tabbing inside the WYSIWYG editor content area
            $(".ql-container").each(function (index) {
                try {
                    var currentEditor = Quill.find($(this).get(0));
                    delete currentEditor.getModule('keyboard').bindings["9"]
                } catch (innerErr) {
                    console.log('Failed to apply WCAG patch for disabling tab in WYSIWYG editor content area index:' + index);
                }
            }); 
        }
        catch(err)
        {
            console.log('Faiedl to apply WCAG patch for WYSIWYG components: {}', err);
        }    
    }   
    

}

var current_doc_to_remove;
var CUSTOM_APPFORM_UTILS = {

    appFormCustomPatches : function () {
        CUSTOM_APPFORM_UTILS.quillLinkPatch();
    },

    quillLinkPatch : function () {
        try {                  	
            // Patch for opening links created in Quill WYSIWYG editor to open in new tab
            $('.rasp-custom-richtext').each(function(index){
                try {
                    $(this).find("a").attr("target","_blank");
                } catch (innerErr) {
                    console.log('Failed to apply Quill WYSIWYG link patch in index:' + index);
                }
            }); 
        } catch(err) {
            console.log('Failed to apply Quill Link Patch: {}', err);
        }    
    },

    showWhenComponent : function(data, component, value)
    {
        try
        {
            if(eval(component)!= undefined && eval(component)!= null)
            {
                var expr = eval(component).constructor;
                switch (expr) {
                    case Array:
                        if(eval(component).length > 0)
                        {
                            var found = false;
                            for (var index = 0; index < eval(component).length; index++) {
                                var element = eval(component)[index];
                                if(element.c_value != undefined && element.c_value != null)
                                {
                                    found = element.c_value.indexOf(value) >=0;
                                }
                                else {
                                    found = element.indexOf(value) >=0;
                                }
                                if(found == true)
                                {
                                    return true;
                                }
                            }
                            return false
                        }
                        else {
                            return false;
                        }
                        
                        break;     
                    case Object:
                        if(Object.keys(eval(component)).indexOf('c_value'))
                        {
                            return eval(component+".c_value").indexOf(value) >=0;
                        }
                        else {
                            return eval(component).indexOf(value) >=0;
                        }
                        break;
                    default:
                        return eval(component) == value; 
                }
            }
            return false;
        }
        catch(err)
        {
            console.log(err);
            return false;
        }
    },

    loadURLSearchParams : function (location, name) {
        try {
            //Load multilanguage parameter from URL, catch tag to deal with I.E. browser
            var urlParams = "";
            var language = "";
            try{
                urlParams = new URLSearchParams(location);
                language = urlParams.get('language');
            }catch(error){
                urlParams = location;
                language = new RegExp('[\?&]language=([^&#]*)').exec(urlParams);
                if(language != null && language != "" && language.length > 0){
                    language = language[1];
                }
            }

            return language;
        } catch(err) {
            console.log('Failed to load multi language: {}', err);
            return null;
        }
    },

    loadUploaderComponent : function (pageIndex, applicationId, allowedFileTypes, clientUrl, sessionId, refDataDocTypes, companionURL, companionAllowedHostsURL, hash) {
        var defaultDocType = 'Resume';
        if($('div .raspUploaderCustComponent').length){
            $('div .raspUploaderCustComponent').each(function(uploadIndex){
                var uploaderId = $(this)[0].id;
                if (true) {

                    try {
                        var uppy = Uppy.Core({
                            debug: true,
                            autoProceed: false,
                            meta: {
                                upload_id: uploaderId,
                                application_id: applicationId,
                                application_version: '1',
                                application_key: hash
                            },
                            allowMultipleUploads: true,
                            restrictions: {
                                maxNumberOfFiles: 10,
                                minNumberOfFiles: 1,
                                allowedFileTypes: allowedFileTypes
                            }
                        }).use(Uppy.Form, {
                            target: '.formAppFormUpload',
                            resultName: 'uppyResult',
                            getMetaFromForm: true,
                            addResultToForm: true,
                            submitOnSuccess: false,
                            triggerUploadOnSubmit: false
                        }).use(Uppy.Dashboard, {
                            inline: true,
                            width: 500,
                            height: 350,
                            target: '#'+uploaderId,
                            allowMultipleUploads: false,
                            proudlyDisplayPoweredByUppy: false,
                            showLinkToFileUploadResult: true,
                            replaceTargetContent: true,
                            locale: {
                              strings: {
                              }
                            }
                        // }).use(Uppy.Dropbox, {
                        //         target: Uppy.Dashboard,
                        //         companionUrl: companionURL,
                        //         companionAllowedHosts: companionAllowedHostsURL
                        // }).use(Uppy.GoogleDrive, {
                        //         target: Uppy.Dashboard,
                        //         companionUrl: companionURL,
                        //         companionAllowedHosts: companionAllowedHostsURL
                        }).use(Uppy.XHRUpload, {
                            id: 'XHRUpload',
                            allowMultipleUploads: false,
                            formData: true,
                            bundle: false,
                            logger: Uppy.debugLogger,
                            encode: 'Base64',
                            restrictions: {
                                allowedFileTypes: allowedFileTypes
                            },
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'OPTIONS, GET, POST, PATCH, PUT',
                                'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                            },
                            //endpoint: 'http://127.0.0.2/application-form/rest-ws/uploadService/fileUpload.jsf?sessionId=#{identity.sessionId}'
                            endpoint: clientUrl + '/application-form/rest-ws/uploadService/fileUpload.jsf?sessionId='+sessionId
                        });
                        $.each($('.uppy-Dashboard-browse'), function(){
                            $(this).attr("aria-label", $('.uppy-Dashboard-dropFilesTitle').text());
                        });
                        
                        $("#"+uploaderId).closest(".formio-component").parent().css("width","100%");
                        
                        //AB: add the event to adjust the height
                        $("#"+uploaderId).on("click", ".uppy-DashboardTab", function(){
                          var provider = $(".uppy-DashboardTab-btn", this).attr("aria-controls");
                          if(provider != undefined){
                            $(".uppy-Dashboard-inner").addClass("expand");
                          }
                        });
                        
                        //AB: add the event to put height back to original
                        $("#"+uploaderId).on("click", ".uppy-DashboardContent-back", function(){
                          $(".uppy-Dashboard-inner").removeClass("expand");
                        });
                        uppy.on('upload-success', function(fileID, response){
                            var docId = response.body.docId;
                            $(".uppy-DashboardContent-addMore").show();
                            attachDeleteOption(fileID,  $("#"+uploaderId), docId);
                            uppy.removeFile(fileID.id);
                            //$('li[id="uppy_'+fileID.id+'"]').find('.doc-type').addClass("disabled").find('option').attr("disabled", true);

                            /*This remoteLoadUploadedFiles is a remotecommand function declared on the page*/
                            remoteLoadUploadedFiles();
                            if($("#"+uploaderId+" .uppy-thumbnails").length == 0){
                                $("#"+uploaderId + " .uppy-Dashboard-inner").after("<div class='uppy-thumbnails'></div>");
                            }
                            var t = "";
                            var a = '<div class="uppy-thumbnail"><i class="fa fa-file-text"></i></div>';
                            var p = "bytes",
                                s = fileID.size;
                            s > 1024 && ((p = "kb"), (s /= 1024) > 1024 && ((s /= 1024), (p = "MB"))),
                                (t +=
                                    '<div class="uppy-thumbnail-container" data-id="' +
                                    fileID.id +
                                    '">' +
                                    a +
                                    ' <span class="uppy-thumbnail-label">' +
                                    fileID.name +
                                    " (" +
                                    Math.round(s, 2) +
                                    " " +
                                    p +
                                    ')</span><span data-id="' +
                                    fileID.id +
                                    '" data-doc-id="doc-' +
                                    docId +
                                    '" class="uppy-remove-thumbnail"><i class="fa fa-trash-o" style="font-size: 1.7rem;"></i></span></div>');
                            $("#"+uploaderId+" .uppy-thumbnails").append(t);
                            if(response.status == 200){
                                uppy.info(response.body.message, response.body.status, 2000);
                            }
                            $("#"+uploaderId).find(".uppy-Dashboard-inner").removeClass("expand");
                        });
                        uppy.on('upload-error', function(file, error, response){
                            // console.log("file", file);
                            var errorMessageComponent = file.meta.upload_id + "_ERROR";
                            var fileName = file.name;
                            var htmlErrorMessage = "";
                            remoteLoadErrorMessage();
                            if (response.status === 413 || response.status === 417) {
                                /*A pop up is added to replace this message*/
                                // htmlErrorMessage = '<div id="ErrorPage" class="maintenancePage">\n' +
                                //     '    <div class="container">\n' +
                                //     '        <div class="header"></div>\n' +
                                //     '        <div class="body">\n' +
                                //     '            <div class="content">\n' +
                                //     '                <div id="errorLongDesc">\n' +
                                //     '                    <div class="maintenanceImg">\n' +
                                //     '                        <img src="/std/error/virus.jpg" alt="Infection Detected" title="Infection Detected"/>\n' +
                                //     '                    </div>\n' +
                                //     '                    <div class="element maintenance">\n' +
                                //     '                        <h1 id="errorTitleText" style="color:#ce1e21;">Infection Detected!</h1>\n' +
                                //     '                        <div class="warnContent">\n' +
                                //     '                            <p>A problem has been detected with one of the files you are trying to upload – it may contain a virus. This file has <u><b>not</b></u> been uploaded.</p>\n' +
                                //     '                            <br/>\n' +
                                //     '                            <p>Affected file: <b style="color:#ce1e21;">'+ fileName +'</b></p>\n' +
                                //     '                            <p style="text-align:center;"><br/><button onclick="$(\'#'+errorMessageComponent+'\').empty();return false;">Back</button></p>\n' +
                                //     '                        </div>\n' +
                                //     '                    </div>\n' +
                                //     '                </div>\n' +
                                //     '            </div>\n' +
                                //     '        </div>\n' +
                                //     '        <div class="footer"></div>\n' +
                                //     '    </div>\n' +
                                //     '</div>';
                            }else{
                                htmlErrorMessage = 'sorry we have failed you. please try again. <p style="text-align:center;"><br/><button onclick="$(\'#'+errorMessageComponent+'\').empty();return false;">Close</button></p>\n';
                            }

                            $("#"+errorMessageComponent).append(htmlErrorMessage);

                        });
                        uppy.on('file-removed', function(file, reason){
                          var dashboardContainer = $("#"+uploaderId);
                          if($(dashboardContainer).find(".upload-help-info").length == 0){
                            $(dashboardContainer).find(".uppy-StatusBar").after('<div class="upload-help-info"><span><i class="mdi mdi-information-variant" aria-hidden="true"></i></span>Please click "Upload file" button to attach the document to your application.</div>');
                          }
                          $(dashboardContainer).find(".uppy-Dashboard-inner").removeClass("expand");
                        });
                        uppy.on('file-added', function(file){
                            setTimeout(function () {
                                var fileID;
                                var dashboardContainer = $("#"+uploaderId);
                                var fileContainer = $("#"+uploaderId).find(".uppy-Dashboard-files");
                                if($(dashboardContainer).find(".upload-help-info").length == 0){
                                  $(dashboardContainer).find(".uppy-StatusBar").after('<div class="upload-help-info"><span><i class="mdi mdi-information-variant" aria-hidden="true"></i></span>Please click "Upload file" button to attach the document to your application.</div>');
                                }
                                $(fileContainer).removeAttr("tabindex");
                                $("#"+uploaderId).find(".uppy-DashboardItem").each(function () {
                                  if( $(this).attr("id") === ('uppy_' + file.id) ) {
                                    fileID = $(this).attr("id");
                                    $(this).find(".uppy-DashboardItem-preview").css("height", "65px");
                                    if (!$(this).find(".doc-type").length) {
                                        var theSelect = '<select aria-label="Please select a document type." id="placeHolderID_'+ uploaderId.replace("uppyUpload_", "") +'" name="placeHolderID_'+ uploaderId.replace("uppyUpload_", "") +'" class="doc-type form-control">'+ refDataDocTypes + '</select>';
                                        $(this).find(".uppy-DashboardItem-fileInfoAndButtons").after("<div class='doc-type-container'><label for='placeHolderID_"+ uploaderId.replace("uppyUpload_", "") +"'>Please confirm the document type:</label>"+theSelect+"</div>");
                                        $(this).find(".doc-type").focus();
                                        $(this).find(".uppy-DashboardItem-fileInfo").append('<input type="hidden" id="fileID_'+ uploaderId.replace("uppyUpload_", "")  +'" name="fileID_'+ uploaderId.replace("uppyUpload_", "")  +'" value="'+fileID+'">');
                                    }
                                    if ($(this).find(".doc-type").val() == "") {
                                        $(this).find(".doc-type").val(defaultDocType);
                                    }
                                    $(this).find(".doc-type").change(function () {
                                        if ($(this).val() != "") {
                                            if ($(this).closest(".uppy-Dashboard-innerWrap").find(".uppy-StatusBar-actions .uppy-StatusBar-actionBtn").hasClass("btn disabled")) {
                                                $(this).closest(".uppy-Dashboard-innerWrap").find(".uppy-StatusBar-actions .uppy-StatusBar-actionBtn").removeClass("btn disabled");
                                                $(this).closest(".uppy-Dashboard-innerWrap").find(".uppy-StatusBar-actions .uppy-StatusBar-actionBtn").prop("disabled", false);
                                            }
                                            $(this).removeClass("invalid");
                                        } else {
                                            if (!$(this).closest(".uppy-Dashboard-innerWrap").find(".uppy-StatusBar-actions .uppy-StatusBar-actionBtn").hasClass("btn disabled")) {
                                                $(this).closest(".uppy-Dashboard-innerWrap").find(".uppy-StatusBar-actions .uppy-StatusBar-actionBtn").addClass("btn disabled");
                                                $(this).closest(".uppy-Dashboard-innerWrap").find(".uppy-StatusBar-actions .uppy-StatusBar-actionBtn").prop("disabled", true);
                                            }
                                            $(this).addClass("invalid");
                                        }
                                    });
                                    $(this).find(".doc-type").keypress(function(event){
                                        var keycode = (event.keyCode ? event.keyCode : event.which);
                                        if(keycode == '13'){
                                            $(fileContainer).parent().find('.uppy-StatusBar-actions button').trigger('click');
                                        }
                                    });
                                    $(".uppy-StatusBar-actions", dashboardContainer).on("click", function(){
                                        if($(this).find('button.disabled').length > 0){
                                            $(".uppy-Dashboard-files").find('.doc-type').filter(function(){
                                                return $(this).val() == "";
                                            }).focus();
                                        }
                                    });
                                  }
                                });
                            }, 500);
                        });
                        function attachDeleteOption(file, componentId, docId) {
                            setTimeout(function () {
                                $(".uppy-DashboardItem").each(function () {
                                    $(this).find(".uppy-DashboardItem-preview").css("height", "65px");
                                });
                                $("#uppyUpload_"+uploaderId.replace("uppyUpload_", "")).each(function () {
                                    $(this).find(".uppy-DashboardItem.is-complete").each(function () {
                                        $(this).find(".uppy-DashboardItem-actionWrapper").addClass("btn-delete-action").html('<button class="uppy-u-reset uppy-DashboardItem-action uppy-DashboardItem-action--remove remove-file-'+uploaderId.replace("uppyUpload_", "")+'" type="button" aria-label="Delete file" title="Delete Uploaded File"><i class="glyphicon glyphicon-trash"></i><svg aria-hidden="true" focusable="false" class="UppyIcon" width="18" height="18" viewBox="0 0 18 18"></svg></button>');
                                    });
                                });
                                $(".remove-file-"+uploaderId.replace("uppyUpload_", "")).click(function () {
                                    uppy.removeFile(file.id);
                                    var uppyFileId = file.id;
                                    uppyFileId = uppyFileId.replace("uppy_","");
                                    uppyFileId = uppyFileId.replace(/[^a-zA-Z0-9,]/ig, "");

                                    /*This remoteDeleteFileBeanCmd is a remotecommand function declared on the page*/
                                    remoteDeleteFileBeanCmd([{
                                        name: 'deleteFileID',
                                        value: uppyFileId
                                    }]);
                                    /*This remoteLoadUploadedFiles is a remotecommand function declared on the page*/
                                    remoteLoadUploadedFiles();
                                });
                                $(".uppy-Dashboard .uppy-thumbnails span.uppy-remove-thumbnail[data-doc-id='doc-"+docId+"']").click(function () {
                                    var uppyFileId = $(this).data("id");
                                    uppyFileId = uppyFileId.replace("uppy_","");
                                    uppyFileId = uppyFileId.replace(/[^a-zA-Z0-9,]/ig, "");
                                    
                                    var docId = $(this).data("doc-id");
                                    current_doc_to_remove = docId;
                                    console.log(docId);
                                    $("."+docId).find(".file-delete").click();
                                    /*This remoteDeleteFileBeanCmd is a remotecommand function declared on the page*/
                                    /*remoteDeleteFileBeanCmd([{
                                        name: 'deleteFileID',
                                        value: uppyFileId
                                    }]);*/
                                    //$('.uppy-Dashboard  .uppy-thumbnail-container[data-id="' + file.id + '"').remove();
                                    /*This remoteLoadUploadedFiles is a remotecommand function declared on the page*/
                                    //remoteLoadUploadedFiles();
                                });

                                // $("#placeHolderID_"+uploaderId.replace("uppyUpload_", "")).change(function () {
                                //     var selectedDocType = $(this).val();
                                //     remoteDocTypeChangeBeanCmd([{
                                //         name: 'selectFileID',
                                //         value: file.id
                                //     }, {
                                //         name: 'selectedVal',
                                //         value: selectedDocType
                                //     }]);
                                // });
                            }, 1000);
                        };

                        function addSelectEvent(file) {
                            var selID = "select_".concat(file.id);
                            document.getElementById(selID).addEventListener("change", function () {
                                selectObj = document.getElementById(selID);
                                var selectedValue = getSelectedValue(selectObj);
                                remoteDocTypeChangeBeanCmd([{
                                    name: 'selectFileID',
                                    value: file.id
                                }, {
                                    name: 'selectedVal',
                                    value: selectedValue
                                }]);
                            });
                        };

                        function getSelectedValue(sel) {
                            return sel.options[sel.selectedIndex].text;
                        };
                    } catch (errr) {
                        console.log(errr);
                        console.log('Fail to load UPPY')
                    }
                }

            });
        }
        var confirmDialog_postShow = PrimeFaces.widget.ConfirmDialog.prototype.postShow;
        PrimeFaces.widget.ConfirmDialog.prototype.postShow = function(){
          confirmDialog_postShow.call(this);
          $(this.footer).find(".ui-confirmdialog-yes").click(function(){
            var docId = current_doc_to_remove;
            if(docId != undefined){
              $("span[data-doc-id="+docId+"]").closest(".uppy-thumbnail-container").remove();
            }
          });
        }

    }


}


function applicationFrom() {
    mobileMenu();

    $('#nav-application #saveDraft[name="data[saveDraft]"]').attr('aria-live', 'polite');
    
    $('.uppy-Dashboard-dropFilesTitle .uppy-Dashboard-browse').attr('aria-label', 'add from your device');
    
    $('#nav-application #saveDraft[name="data[saveDraft]"]').click(function () {
        $(this).attr('aria-live', 'off');
        setTimeout(function () {
            $(this).attr('aria-live', 'polite');
        }, 300);
    });
    
    setTimeout(function () {

        $('#nav-welcome .section-body .container .box').attr('role', 'presentation');
        
        //flatpickr("input[placeholder='dd/MM/yyyy']");

        $('#fileUploadDiv .row a.btn-link.file-delete').each(function () {
            var textFile = $(this).closest('.col-xs-12').find('.col-xs-11 .file-link').text();
            var titleIcon = 'Delete ' + textFile;
            $(this).attr('title', titleIcon);
            $(this).attr('aria-label', titleIcon);
        });

        $('.formio-component-select .form-control select[tabindex="-1"]').each(function () {
            $(this).closest('.formio-component-select').find('.control-label').removeAttr('for');
            $(this).closest('.formio-choices').attr('aria-label', 'button');
            $(this).closest('.formio-choices').removeAttr('role');
            $(this).closest('.formio-choices').removeAttr('tabindex');
            if ($(this).closest('.form-control[tabindex="0"]').length) {
                $(this).closest('.form-control[tabindex="0"]').attr('role', 'button');
            } else {
                $(this).closest('div.form-control').attr('role', 'button');
                $(this).closest('div.form-control').attr('tabindex', '0');
            }
            
        });
        
        var inputs = document.querySelectorAll('.choices__input.choices__input--cloned');

        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            var inputId = 'input-' + (i + 1);
            var placeholderText = input.getAttribute('placeholder');

            if (!placeholderText || placeholderText.length < 1) {
                placeholderText = 'Enter the value';
            }

            if (!document.querySelector('label[for="' + inputId + '"]')) {
                input.id = inputId;
                input.insertAdjacentHTML('beforebegin', '<label style="font-size:0;position:absolute;" for="' + inputId + '">' + placeholderText + '</label>');
            }
        }       

        $('.raspUploaderCustComponent ').attr('role', 'presentation');

        $('.formio-component .input-group input.form-control[placeholder="dd/MM/yyyy"]').each(function () {
            var input = $(this);
            var IDdate = input.attr('id');
            if (!IDdate) {
                input.closest('.input-group').find('.form-control').removeAttr('id');
                var IDInput = input.closest('.formio-component').find('.control-label').attr('for');
                input.attr('id', IDInput);
            }
            input.closest('.input-group').find('.fa').attr('aria-hidden', 'true');
            input.closest('.input-group').find('.input-group-addon').attr({
                'tabindex': '0',
                'role': 'button',
                'aria-label': 'Open Calendar'
            });
        });
        
        $(document).keyup(function (e) {
            //add clsss when delete icon press
            $('.uppy-thumbnails .uppy-thumbnail-container .uppy-remove-thumbnail').each(function () {
                var textFile = $(this).closest('.uppy-thumbnail-container').find('.uppy-thumbnail-label').text();
                var titleIcon = 'Delete ' + textFile;
                $(this).attr('title', titleIcon);
                $(this).attr('aria-label', titleIcon);
            });

            var currentActive = document.activeElement;
            var dob = $(currentActive).attr('aria-label');
            if (e.keyCode == 13 || e.keyCode == 32) {

                //add clsss when delete icon press
                if ($(currentActive).hasClass("file-delete")) {
                    $(currentActive).addClass('dialog-box-open');
                }

                //add clsss for confirmdialog
                if ($(currentActive).hasClass("ui-confirmdialog-no")) {
                    $('.file-delete.dialog-box-open').focus();
                    $('.file-delete.dialog-box-open').removeClass('dialog-box-open');
                }

                //click and add clsss for remove icon whix has span
                if ($(currentActive).hasClass("uppy-remove-thumbnail")) {
                    $(currentActive).click();
                    $(currentActive).addClass('dialog-box-open');
                }

                if ($(currentActive).hasClass("btn-secondary")) {
                    $(currentActive).click();
                }

                if ($(currentActive).has('#saveDraft[name="data[saveDraft]"]')) {
                    $(currentActive).click();
                }

            }

            //ese press
            if (e.keyCode == 27) {
                //close dialog and focus revert
                if ($('.dialog-box-open').length) {
                    $('.dialog-box-open').focus();
                    $('.dialog-box-open').removeClass('dialog-box-open');
                }

                //close dialog and focus revert
                if ($('.ui-confirm-dialog').is(':visible')) {
                    $('.ui-confirm-dialog .ui-confirmdialog-no').click();
                }

                //close calendar and focus revert
                if ($('.flatpickr-calendar').is(':visible')) {
                    $('input.hasDatepicker-Show').focus();
                    $('.flatpickr-calendar').hide();
                    $('input.hasDatepicker-Show').removeClass('hasDatepicker-Show');
                }
            }

            if (e.keyCode == 9) {
                if ($('div[id*="virusInfoDialog"].ui-dialog.modalWin').is(':visible')) {
                    $('div[id*="virusInfoDialog"].ui-dialog.modalWin .ui-button.btn-secondary').focus();
                }

                if (dob == 'Date of Birth') {
                    $(dob).addClass('hasDatepicker-Show');
                    $('.flatpickr-calendar').attr('tabindex', '0').focus();
                    $('.flatpickr-calendar [tabindex]').attr('tabindex', '0');
                }
            }
        });

        $(document).keydown(function (e) {
            var currentActive = document.activeElement;

            if (e.keyCode == 9) {
                if ($('.uppy-thumbnail-container').length) {
                    $('.uppy-remove-thumbnail').attr('tabindex', '0');
                }
            }
        });
        
        //WCAG of Datepicker 
        $(document).on('click focus', 'input#AP_APPLICATION_DOB', function () {
            focusDatePicker();
        });
        
        $(document).keyup(function (e) {
            
            if ($('.flatpickr-calendar').is(':visible')) {
                var firstCalendarLink = $('.flatpickr-calendar').find(':focusable').first();
                var lastCalendarLink = $('.flatpickr-calendar').find(':focusable').last();
            }
            if (e.keyCode == 9) { // Tab key
                focusDatePicker();
            }

            if (e.keyCode == 9) {
                if (document.activeElement === lastCalendarLink[0]) {
                    firstCalendarLink.focus();
                    setTimeout(function () {
                        firstCalendarLink.focus();
                    }, 100);
                }
            }

            if (e.shiftKey && e.keyCode == 9) {
                if (document.activeElement === firstCalendarLink[0]) {
                    lastCalendarLink.focus();
                }
            }
        });
        
        function focusDatePicker() {

            if ($('.flatpickr-calendar').is(':visible')) {
                var firstCalendarLink = $('.flatpickr-calendar').find(':focusable').first();
                var lastCalendarLink = $('.flatpickr-calendar').find(':focusable').last();

                var datePickerDiv = $('.flatpickr-calendar');
                var todayDate = datePickerDiv.find('.flatpickr-day.today');

                // Ensure navigation buttons are accessible
                datePickerDiv.find('span.flatpickr-next-month, span.flatpickr-prev-month').attr({
                    'tabindex': '0',
                    'role': 'button'
                });

                datePickerDiv.find('span.flatpickr-prev-month').attr('aria-label', 'Previous Month');
                datePickerDiv.find('span.flatpickr-next-month').attr('aria-label', 'Next Month');

                datePickerDiv.find('.flatpickr-rContainer').attr({
                    'role': 'application',
                    'aria-label': 'Select date'
                });

            }
        }    
        
    }, 500);
}

function mobileMenu() {
    var isMobile = /Mobi/i.test(navigator.userAgent);
    if (isMobile) {
        $(document).keydown(function (e) {
            if ($('.navbar.navbar-collapse.collapse.in').length) {
                var activeMenuLink = document.activeElement;
                var firstMenuLink = $('.site-header').find(':focusable').first();
                var lastMenuLink = $('.site-header').find(':focusable').last();

                if (e.keyCode == 27) {
                    if($('.navbar-toggle.active').length){
                        $('.navbar-toggle.active').click();                       
                    }
                }
                
                if (e.keyCode == 9) {
                    if (document.activeElement === lastMenuLink[0]) {
                        firstMenuLink.focus();
                        setTimeout(function () {
                            firstMenuLink.focus();
                        }, 100);
                    }
                }
                
                if (e.shiftKey && e.keyCode == 9) {
                    if (document.activeElement === firstMenuLink[0]) {
                        lastMenuLink.focus();
//                        setTimeout(function () {
//                            lastMenuLink.focus();
//                        }, 100);
                    }
                }
            }
        });
    }
}